<script>
export default {
  name: 'has-pagination',
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null
    };
  },
  computed: {
    // Persist page per-route to avoid mixing states across views
    paginationStorageKey () {
      return `blonie-crm-pagination:${this.$route.path}`;
    }
  },
  beforeMount () {
    // Restore saved page before first data load
    const savedPage = localStorage.getItem(this.paginationStorageKey);
    const parsedPage = savedPage ? parseInt(savedPage, 10) : null;

    if (parsedPage && parsedPage > 0) {
      this.currentPage = parsedPage;
    }

    this.$bus.$emit('pagination-set-page', {
      view: this.$route.path,
      page: this.currentPage
    });
  },
  mounted () {
    // Listen for page changes triggered by Pagination component
    this.$bus.$on('pagination-page-changed', this.setPage);
    this.$bus.$on('pagination-reset', this.resetPagination);
  },
  methods: {
    setPage (page) {
      this.currentPage = page;
      this.debouncedLoadFilteredData();
    },
    resetPagination () {
      this.currentPage = 1;
      this.debouncedLoadFilteredData();
    }
  },
  watch: {
    currentPage (newVal) {
      // Save page and broadcast to keep Pagination in sync
      localStorage.setItem(this.paginationStorageKey, newVal);
      this.$bus.$emit('pagination-set-page', {
        view: this.$route.path,
        page: newVal
      });
    },
    paginationMetaData (newVal) {
      if (!newVal || !newVal.last_page) {
        return;
      }

      const maxPage = newVal.last_page > 0 ? newVal.last_page : 1;

      if (this.currentPage > maxPage) {
        // If current page exceeds available pages, clamp and reload
        this.currentPage = maxPage;

        if (typeof this.debouncedLoadFilteredData === 'function') {
          this.debouncedLoadFilteredData();
        }
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('pagination-page-changed', this.setPage);
    this.$bus.$off('pagination-reset', this.resetPagination);
  }
}
</script>
